import { Route } from "@src/typings/routes";
import homeRoutes from "./homeRoutes";

const Routes: Route[] = [...homeRoutes];

export default Routes;
